import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, setAdminToken, formatApiError } from "@/lib/api";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      const res = await api.adminLogin(email, password);
      setAdminToken(res.token);
      nav("/admin", { replace: true });
    } catch (e2) {
      setErr(formatApiError(e2));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="grain min-h-screen flex items-center justify-center bg-[var(--fsyl-bg)] px-6" data-testid="admin-login-page">
      <div className="w-full max-w-md fade-up">
        <div className="font-mono-fsyl text-[10px] tracking-[0.4em] text-[var(--fsyl-cyan)] mb-4">// ADMIN ACCESS</div>
        <h1 className="font-display font-black text-5xl tracking-tighter mb-10">FYSL / CONSOLE</h1>

        <form onSubmit={onSubmit} className="space-y-5">
          <div>
            <label className="block font-mono-fsyl text-[10px] tracking-widest text-[var(--fsyl-muted)] mb-2">EMAIL</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="admin-email"
              className="w-full bg-[var(--fsyl-surface)] border border-white/10 focus:border-[var(--fsyl-cyan)] outline-none px-3 py-3 font-mono-fsyl text-sm"
              required
            />
          </div>
          <div>
            <label className="block font-mono-fsyl text-[10px] tracking-widest text-[var(--fsyl-muted)] mb-2">PASSWORD</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-password"
              className="w-full bg-[var(--fsyl-surface)] border border-white/10 focus:border-[var(--fsyl-cyan)] outline-none px-3 py-3 font-mono-fsyl text-sm"
              required
            />
          </div>
          {err && <div className="font-mono-fsyl text-[11px] tracking-widest text-red-400" data-testid="admin-login-error">✕ {err.toUpperCase()}</div>}
          <div className="flex items-center justify-between pt-4">
            <button
              type="submit"
              disabled={busy}
              data-testid="admin-login-submit"
              className="font-mono-fsyl text-[11px] tracking-[0.3em] uppercase px-6 py-3 border border-white/15 hover:border-[var(--fsyl-cyan)] hover:text-[var(--fsyl-cyan)] transition disabled:opacity-40"
            >
              {busy ? "AUTHENTICATING..." : "→ ENTER CONSOLE"}
            </button>
            <button type="button" onClick={() => nav("/")} className="font-mono-fsyl text-[10px] tracking-widest text-[var(--fsyl-dim)] hover:text-[var(--fsyl-muted)]">
              ← BACK
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
